import { UserNoticeSubSectionType } from './UserNoticeSubSectionType';
import { UserNoticeSectionType } from './UserNoticeSectionType';

export const UserNoticeSubSectionTypeOptions = [
    {
        sectionId: UserNoticeSectionType.Open,
        subSectionId: UserNoticeSubSectionType.Open,
        name: 'Open Applications/Approved Loans',
    },
    {
        sectionId: UserNoticeSectionType.Closed,
        subSectionId: UserNoticeSubSectionType.Closed,
        name: 'Outstanding Loans',
    },
    {
        sectionId: UserNoticeSectionType.DeadDeals,
        subSectionId: UserNoticeSubSectionType.DeclinedByBFI,
        name: 'Declined By BFI',
    },
    {
        sectionId: UserNoticeSectionType.DeadDeals,
        subSectionId: UserNoticeSubSectionType.Lost,
        name: 'Lost',
    },
    {
        sectionId: UserNoticeSectionType.Repaid,
        subSectionId: UserNoticeSubSectionType.Repaid,
        name: 'Repaid Loans',
    },
    {
        sectionId: UserNoticeSectionType.Missing,
        subSectionId: UserNoticeSubSectionType.Missing,
        name: 'Missing Notices',
    },
    {
        sectionId: UserNoticeSectionType.All,
        subSectionId: UserNoticeSubSectionType.All,
        name: 'All',
    },
];
